var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotAttempted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3887",
    "data-name": "Group 3887",
    transform: "translate(15770 -8566)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2982",
    "data-name": "Rectangle 2982",
    width: 16,
    height: 16,
    transform: "translate(-15770 8566)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3886",
    "data-name": "Group 3886",
    transform: "translate(-5595 1391)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_336",
    "data-name": "Ellipse 336",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(-10174 7176)",
    fill: "#feb300"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3723",
    "data-name": "Group 3723"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2951",
    "data-name": "Rectangle 2951",
    width: 2,
    height: 5,
    rx: 1,
    transform: "translate(-10168 7179)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2952",
    "data-name": "Rectangle 2952",
    width: 2,
    height: 2,
    rx: 1,
    transform: "translate(-10168 7185)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAttempted);
export default __webpack_public_path__ + "static/media/not-attempted.03efad3ee4935973c31f6b25666f1df2.svg";
export { ForwardRef as ReactComponent };